/**
 * Highlight http:// and https:// URLs in text elements
 * @param {string} selector - CSS selector for elements to process
 */
function highlightLinks(selector) {
    document.querySelectorAll(selector).forEach(function(element) {
        const $element = $(element);
        if ($element.find('a').length > 0 || !$element.html()?.trim()) {
            return;
        }

        const html = $element.html();

        const urlPattern = /(https?:\/\/[^\s<]+)/gi;
        const linkified = html.replace(urlPattern, function(url) {
            return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + '</a>';
        });

        if (linkified !== html) {
            $element.html(linkified);
        }
    });
}

$(function() {
    highlightLinks('.highlight-links');
});

if (typeof module !== 'undefined' && module.exports) {
    module.exports = highlightLinks;
}

window.highlightLinks = highlightLinks;
